"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function OrganizationadministratorBlueMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__organizationadministrator-blue-multitone-filled__clip0_13467_206)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CAF0FC",
    fillRule: "evenodd",
    d: "M10.72 6.484c-.28-.001-.554.08-.787.234a1.389 1.389 0 00-.22 2.157 1.42 1.42 0 001.543.306c.259-.106.48-.286.636-.517a1.391 1.391 0 00-.174-1.768 1.423 1.423 0 00-.998-.412zm3.527 5.486a2.596 2.596 0 00-1.627-.748l-1.9 2.145-1.899-2.145a2.625 2.625 0 00-1.702.826c-.443.476-.69 1.1-.69 1.748v1.167h8.563v-1.128a2.539 2.539 0 00-.745-1.825v-.04z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M14.957 11.302a3.59 3.59 0 00-2.56-1.048h-.23l-1.447 1.641-1.45-1.64h-.232a3.644 3.644 0 00-2.56 1.047 3.574 3.574 0 00-1.057 2.534V16H16v-2.165a3.521 3.521 0 00-1.043-2.533zm.05 3.7H6.444v-1.167a2.574 2.574 0 01.691-1.747 2.624 2.624 0 011.702-.826l1.9 2.144 1.899-2.144c.651.054 1.259.348 1.701.825.443.477.688 1.101.687 1.748l-.015 1.168z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M10.72 5.486a2.44 2.44 0 00-1.347.402c-.4.263-.71.638-.895 1.076A2.377 2.377 0 009 9.58a2.447 2.447 0 002.641.522 2.418 2.418 0 001.089-.883 2.382 2.382 0 00-.3-3.028 2.435 2.435 0 00-1.71-.705zm0 3.796c-.28 0-.554-.08-.788-.234a1.389 1.389 0 01-.218-2.158 1.42 1.42 0 011.545-.304c.26.107.48.288.636.519.155.231.237.503.236.78a1.39 1.39 0 01-.408 1 1.416 1.416 0 01-1.003.417v-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAF0FC",
    d: "M1.008.998v13.965H5.44V.998H1.008zM4.09 13.416H2.312v-.997h1.779v.997zm0-2.443H2.312v-.998h1.779v.998zm0-2.444H2.312V7.53h1.779v.998zm0-2.444H2.312v-.998h1.779v.998zm0-2.574H2.312V2.494h1.779V3.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M0 0v15.96h6.448L6.473 0H0zm5.42 14.963H.988V.998h4.434v13.965z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M4.09 5.087H2.314v.998H4.09v-.998zM4.09 7.531H2.314v.998H4.09V7.53zM4.09 9.975H2.314v.998H4.09v-.998zM4.09 12.419H2.314v.997H4.09v-.997zM4.09 2.514H2.314v.997H4.09v-.997z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__organizationadministrator-blue-multitone-filled__clip0_13467_206"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

OrganizationadministratorBlueMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
OrganizationadministratorBlueMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = OrganizationadministratorBlueMultitoneFilled;
exports["default"] = _default;